import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable()
export class OverviewV2Guard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const queryParams = { ...route.queryParams };
    if (route.queryParams.trainingId) {
      delete queryParams.trainingId;
      this.router.navigate([`/overview/training/${route.queryParams.trainingId}`], { queryParams });
    }
    if (route.queryParams.companyId) {
      delete queryParams.companyId;
      this.router.navigate([`/overview/company/${route.queryParams.companyId}`], { queryParams });
    }
    return true;
  }
}
